import React from 'react';
import './App.css';
// import PLS from "https://localhost:3000/PLS_Primary_Logo_on_dark.png";
import Landing from "./Components/Landing.jsx"
import FileUnlocker from "./Components/FileUnlocker.jsx"

function App() {
  return (
    <div className="App">
		<Landing />
		<img className="logo-PLS" src={"./PLS_Primary_Logo_on_dark.png"} alt="PLS-Solicitors" />
        <h1 className="title">Intranet File Unlocker</h1>

		<FileUnlocker />
    </div>
  );
}

export default App;
